import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, AfterViewInit, ViewChildren, QueryList, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Tab } from '../../../interfaces/tab.interface';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-new-project-tabs',
  templateUrl: './new-project-tabs.component.html',
  styleUrls: ['./new-project-tabs.component.css'],
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewProjectTabsComponent implements AfterViewInit {
  @Input() activeTab: string = 'informacion-general';
  @Output() tabChange = new EventEmitter<string>();
  @ViewChildren('tabButton') tabButtons!: QueryList<ElementRef>;

  indicatorWidth: string = '0px';
  indicatorLeft: string = '0px';

  // Tabs disponibles
  readonly tabs: Tab[] = [
    { id: 'informacion-general', label: 'INFORMACIÓN GENERAL', icon: '🏠' },
    { id: 'galeria', label: 'GALERÍA', icon: '📸' },
    { id: 'resumen-financiero', label: 'RESUMEN FINANCIERO', icon: '💰' },
    { id: 'calendario', label: 'CALENDARIO', icon: '📅' },
    { id: 'documentacion', label: 'DOCUMENTACIÓN', icon: '📄' }
  ];

  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.updateIndicator();
    }, 0);
  }

  setActiveTab(tabId: string): void {
    this.activeTab = tabId;
    this.updateIndicator();
    this.tabChange.emit(tabId);
  }

  updateIndicator(): void {
    if (this.tabButtons) {
      const activeIndex = this.tabs.findIndex(tab => tab.id === this.activeTab);
      const activeButton = this.tabButtons.toArray()[activeIndex];
      
      if (activeButton) {
        const element = activeButton.nativeElement;
        const textElement = element.querySelector('.tab-label');
        
        if (textElement) {
          // Obtener el ancho del texto
          const textWidth = textElement.offsetWidth;
          
          // Obtener la posición del botón
          const buttonLeft = element.offsetLeft;
          const buttonWidth = element.offsetWidth;
          
          // Calcular la posición del texto centrado
          const textLeft = buttonLeft + (buttonWidth - textWidth) / 2;
          
          // Ajustar por el padding del contenedor del indicador
          // 60px en desktop, 30px en móvil
          const isMobile = window.innerWidth <= 768;
          const paddingOffset = isMobile ? 30 : 60;
          const indicatorLeft = textLeft - paddingOffset;
          
          this.indicatorWidth = `${textWidth}px`;
          this.indicatorLeft = `${indicatorLeft}px`;
        } else {
          // Fallback
          const width = element.offsetWidth;
          const isMobile = window.innerWidth <= 768;
          const paddingOffset = isMobile ? 30 : 60;
          const left = element.offsetLeft - paddingOffset;
          this.indicatorWidth = `${width}px`;
          this.indicatorLeft = `${left}px`;
        }
        
        this.cdr.detectChanges();
      }
    }
  }

  trackByTabId(index: number, tab: Tab): string {
    return tab.id;
  }
}
